
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"22","viewBox":"0 0 21 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":"0.5","width":"21","height":"21","rx":"10.5","fill":"#1758F5"}}),_c('path',{attrs:{"d":"M8.74293 15C8.67282 15 8.60854 14.988 8.55011 14.964C8.49168 14.9401 8.43325 14.8981 8.37482 14.8382L5.14946 11.5303C5.04428 11.4225 4.99462 11.2966 5.00046 11.1528C5.0063 11.009 5.06181 10.8831 5.16699 10.7753C5.27216 10.6674 5.39487 10.6135 5.5351 10.6135C5.67533 10.6135 5.79804 10.6674 5.90321 10.7753L8.74293 13.6876L15.106 7.1618C15.2112 7.05393 15.3339 7 15.4741 7C15.6144 7 15.7371 7.05393 15.8422 7.1618C15.9474 7.26966 16 7.3985 16 7.54831C16 7.69813 15.9474 7.82697 15.8422 7.93483L9.11105 14.8382C9.05262 14.8981 8.99418 14.9401 8.93575 14.964C8.87732 14.988 8.81305 15 8.74293 15Z","fill":"white"}})])
          )
        }
      }
    